var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_8000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 11,
    height: 14,
    rx: 2,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 1,
    width: 12,
    height: 10,
    rx: 2,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    width: 12,
    height: 14,
    rx: 2,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 19,
    width: 11,
    height: 10,
    rx: 2,
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_8000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardW);
export default __webpack_public_path__ + "static/media/dashboardW.81c6dbca1de8426fb02c6d9dec815e98.svg";
export { ForwardRef as ReactComponent };